import Dashboard from "layouts/dashboard";
import SorguPage from "layouts/sorgu";
import { IoHome, IoSearch } from "react-icons/io5";
import { sorgular } from "sorgu/queries";

function buildRoutes(kullanici_bilgisi) {
  let hazirlanan_yollar = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      icon: <IoHome size="15px" color="inherit" />,
      component: Dashboard,
      noCollapse: true,
    },
  ];

  const anahtarlar_kat = Object.keys(sorgular);

  for (let c = 0; c < anahtarlar_kat.length; c++) {
    const guncel_kategoriId = anahtarlar_kat[c];
    const guncel_kategori = sorgular[guncel_kategoriId];
    const alt_sorgular = Object.keys(guncel_kategori.sorgu);

    if (alt_sorgular.length > 0) {
      hazirlanan_yollar.push({ type: "title", title: guncel_kategori.baslik, key: "title-" + guncel_kategoriId });

      for (let indexSorgu = 0; indexSorgu < alt_sorgular.length; indexSorgu++) {
        let gercek_kod = alt_sorgular[indexSorgu];
        let ozel_sorgu = guncel_kategori.sorgu[gercek_kod];

        hazirlanan_yollar.push({
          type: "collapse",
          name: ozel_sorgu.ad,
          key: "sorgu-" + gercek_kod,
          route: "/sorgu/" + gercek_kod,
          icon: <IoSearch size="15px" color="inherit" />,
          component: SorguPage,
          noCollapse: true,
          locked: false,
        });
      }
    }
  }

  return hazirlanan_yollar;
}

export default buildRoutes;
